import React from 'react'
import classnames from 'classnames'

const OfferResposeFilters = ({ onFilterToggle, onViewToggle, listView, view }) =>
    <nav className="navbar navbar-content">
        <div className="container-fluid">
            <ul className="content-tabs nav navbar-nav">
                <li>
                    <a style={{cursor:"pointer"}} onClick={onFilterToggle}
                        className="filters-btn collapsed"
                        data-toggle="collapse">Filters</a>
                </li>
            </ul>
            {view === 'book-a-flight' &&
              <ul className="content-tabs nav navbar-nav navbar-right ">
                  <li>
                      <a onClick={onViewToggle}
                          className={classnames("view-compact-btn", {"selected":!listView} )}
                          data-toggle="collapse">Compact</a>
                  </li>
                  <li>
                      <a onClick={onViewToggle}
                          className={classnames("view-list-btn", {"selected":listView} )}
                          data-toggle="collapse">List</a>
                  </li>
              </ul>
            }
        </div>
    </nav>

export default OfferResposeFilters



// WEBPACK FOOTER //
// ./src/ndc/offer/OfferResponseFilters.js